import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionDevices } from '../../actions/devices_actions.jsx';
import { withTranslation, Trans } from 'react-i18next';
import ToogleButton from '../controls/buttons/toogle_button.jsx';

const emptyDeviceSettings = {
    deviceIoSettingsId: 0,
    volumeCountIoId: "",
    volumeRatio: "",
    valveIoId: "",
    userKeyIoId: ""
};

const emptyDevice = {
        deviceImei: "",
        name: "",
        description: "",
        protocolType: "",
        isActive: true,
        deviceIoSettings: emptyDeviceSettings
    };

class EditDevice extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.item) {
            this.state = {
                item: { ...this.props.item, deviceIoSettings: {} }, isNewDevice: false };
        } else {
            this.state = {
                item: emptyDevice,
                isNewDevice: true
            };
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cancelEditDevice = this.cancelEditDevice.bind(this);
    }

    componentDidMount() {
        if (this.state.isNewDevice) {
            return;
        }

        const devImei = this.state.item.deviceImei;
        this.props.getDevice(devImei).then(device => {
            this.setState({ ...this.state, item: device });
        });
    }

    handleSubmit(e) {
        e.preventDefault();
        let newState = Object.assign({}, this.state);
        newState.item.deviceImei = this.refs.deviceImei.value;
        newState.item.name = this.refs.name.value;
        newState.item.description = this.refs.description.value;
        newState.item.protocolType = this.refs.protocolType.value;
        newState.item.isActive = this.refs.isActive.state.active;
        newState.item.deviceIoSettings.volumeCountIoId = this.refs.deviceIoSettings_volumeCountIoId.value;
        newState.item.deviceIoSettings.volumeRatio = this.refs.deviceIoSettings_volumeRatio.value;
        newState.item.deviceIoSettings.valveIoId = this.refs.deviceIoSettings_valveIoId.value;
        newState.item.deviceIoSettings.userKeyIoId = this.refs.deviceIoSettings_userKeyIoId.value;
        this.setState(newState);

        if (this.state.isNewDevice) {
            this.props.addDevice(newState.item);
        } else {
            this.props.editDevice(newState.item);
        }
    }

    cancelEditDevice(e) {
        e.preventDefault();
        this.props.history.goBack();
    }

    render() {
        return (
            <div className="form_container">
                <form onSubmit={this.handleSubmit}>
                    <div className="form-body">
                        <div className="left-panel">
                            <p>
                                <label><Trans>Devices.deviceImei</Trans></label>
                                <input type="text" ref="deviceImei" defaultValue={this.state.item.deviceImei} disabled={!this.state.isNewDevice}/>
                            </p>
                            <p>
                                <label><Trans>Devices.name</Trans></label>
                                <input type="text" ref="name" defaultValue={this.state.item.name}/>
                            </p>
                            <p>
                                <label><Trans>Devices.description</Trans></label>
                                <input type="text" ref="description" defaultValue={this.state.item.description}/>
                            </p>
                            <p>
                                <label><Trans>Devices.protocolType</Trans></label>
                                <input type="text" ref="protocolType" defaultValue={this.state.item.protocolType}/>
                            </p>
                            <p className="toogle-element">
                                <label><Trans>Devices.isActive</Trans></label>
                                <ToogleButton ref="isActive" defaultValue={this.state.item.isActive}/>
                            </p>
                        </div>
                        <div className="right-panel">
                            <p>
                                <label><Trans>Devices.deviceIoSettings.volumeCountIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_volumeCountIoId" defaultValue={this.state.item.deviceIoSettings.volumeCountIoId}/>
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.volumeRatio</Trans></label>
                                <input type="text" ref="deviceIoSettings_volumeRatio" defaultValue={this.state.item.deviceIoSettings.volumeRatio}/>
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.valveIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_valveIoId" defaultValue={this.state.item.deviceIoSettings.valveIoId}/>
                            </p>
                            <p>
                                <label><Trans>Devices.deviceIoSettings.userKeyIoId</Trans></label>
                                <input type="text" ref="deviceIoSettings_userKeyIoId" defaultValue={this.state.item.deviceIoSettings.userKeyIoId}/>
                            </p>
                        </div>
                    </div>
                    <div className="form-buttons-container">
                        <button type="submit"><Trans>Table.saveButton</Trans></button>
                        <button onClick={this.cancelEditDevice}><Trans>Table.cancelButton</Trans></button>
                    </div>
                </form>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let id = ownProps.match.params.id;
    return {
        item: id ? state.devices.devices.find(x => x.deviceImei === id) : null
    };
}

const mapDispatch = (dispatch, ownProps) => {
    return {
        editDevice: device => dispatch(actionDevices.editDevice(device, ownProps)),
        addDevice: device => dispatch(actionDevices.addDevice(device, ownProps)),
        getDevice: deviceImei => dispatch(actionDevices.getDevice(deviceImei))
    };
};


export default withRouter(connect(mapStateToProps, mapDispatch)(withTranslation('translantions')(EditDevice)));